import { render, staticRenderFns } from "./OptionsValues.vue?vue&type=template&id=1ba113ca&scoped=true&"
import script from "./OptionsValues.vue?vue&type=script&lang=js&"
export * from "./OptionsValues.vue?vue&type=script&lang=js&"
import style0 from "./OptionsValues.vue?vue&type=style&index=0&id=1ba113ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba113ca",
  null
  
)

export default component.exports